import ArchivedProductProfileLibrary from './ArchivedProductProfileLibrary';

export default ArchivedProductProfileLibrary;
